// Big round record/stop button with a visible caption (the whole thing is one touch target).
import { Icon } from './Icon';

interface RecordButtonProps {
  /** Shows the stop icon. */
  recording: boolean;
  /** Red pulse animation; defaults to `recording` (off while paused). */
  pulse?: boolean;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Shows a spinner instead of the icon (microphone opening, saving). */
  busy?: boolean;
  size?: 'lg' | 'md';
  /** Marks the button as the push-to-talk target (see Inspection page). */
  ptt?: boolean;
  /** Accessible name when it should differ from the caption. */
  ariaLabel?: string;
  className?: string;
}

export function RecordButton({ recording, pulse = recording, label, onClick, disabled, busy, size = 'lg', ptt, ariaLabel, className }: RecordButtonProps) {
  return (
    <button
      type="button"
      className={`record-btn record-btn--${size}${recording ? ' is-recording' : ''}${pulse ? ' is-pulsing' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-busy={busy || undefined}
      data-ptt={ptt ? '' : undefined}
    >
      <span className="record-btn__circle">
        <Icon name={busy ? 'spinner' : recording ? 'stop' : 'mic'} size={size === 'lg' ? 44 : 36} />
      </span>
      <span className="record-btn__label">{label}</span>
    </button>
  );
}
